module.exports = __webpack_public_path__ + "media/images/country_flags/fm-f2723cb8d86bbbd8084ca66038009d3f.png";